<template>
    <div>
        <label
            class="title bold"
            v-if="!hideLabel">
            <span v-if="label">{{ label }}</span>
            <span v-else>{{ mode == "image" ? "Afbeelding" : "Video" }}</span>
        </label>
        <div
            class="upload-container"
            :class="`${inline && 'inline'}`">
            <div
                class="upload-container__image"
                :class="`${loading && 'disabled'} size-${size}`"
            >
                <div
                    :class="`upload-container__image__ratio ratio-${ratio} ${
                        round && 'round'
                    }`"
                >
                    <video-player
                        v-if="value && mode == 'video'"
                        class="video-player-box"
                        ref="videoPlayer"
                        :options="playerOptions"
                        :playsinline="true"
                    >
                    </video-player>
                    <img
                        v-else-if="imageSrc && mode == 'image'"
                        :src="imageSrc"
                    />
                    <label
                        v-else
                        :for="'file' + uniqueId"
                        class="upload-container__image__ratio__content"
                    >
                        <i
                            v-if="loading"
                            class="i-load spinning"></i>
                        <i
                            v-else-if="mode == 'image'"
                            class="i-img"></i>
                        <i
                            v-else-if="mode == 'video'"
                            class="i-video"></i>
                    </label>
                </div>
            </div>
            <span
                v-if="value || preview"
                class="subtitle clickable"
                @click="reset(mode)"
            >Verwijder {{ mode == "image" ? "afbeelding" : "video" }}</span
            >
        </div>
        <input
            :id="'file' + uniqueId"
            type="file"
            ref="files"
            :accept="accept[mode]"
            class="core-upload-file-input"
            @change="upload"
            multiple
        />
    </div>
</template>
<script>
import 'video.js/dist/video-js.css';

import { videoPlayer } from 'vue-video-player';

let UID = 0;
export default {
    components: {
        videoPlayer
    },
    data() {
        return {
            uniqueId: UID++,
            accept: {
                video: 'video/mp4',
                image: 'image/x-png,image/gif,image/jpeg'
            },
            loading: false,
            response: false
        };
    },
    props: {
        value: {
            default: null
        },
        mode: {
            type: String,
            default: 'image'
        },
        url: {
            type: String
        },
        label: {
            type: String
        },
        ratio: {
            type: String,
            default: '16-9'
        },
        round: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        preventUpload: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'large'
        },
        preview: {
            type: String,
            default: ''
        },
        payload: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        upload() {
            if (this.value) this.loading = true;
            let file = this.$refs.files.files[0];
            let formData = new FormData();

            if (this.preventUpload) {
                this.$emit('input', file);
            } else {
                formData.append(this.mode, file);

                const route = this.route(this.url, this.payload);

                this.axios.post(route, formData).then((response) => {
                    this.loading = false;
                    const filePath = `/storage/${response.data.url}`;

                    if (this.mode == 'video') {
                        this.playerOptions.sources[0].src = filePath;
                    }

                    this.response = response.data.url;
                    this.$emit('input', response.data.url);
                });
            }
        },
        isURL(str) {
            var pattern = new RegExp(
                '^(https?:\\/\\/)?' + // protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
                    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                    '(\\#[-a-z\\d_]*)?$',
                'i'
            ); // fragment locator
            return pattern.test(str);
        },
        reset(mode) {
            this.$emit('input', null);
        }
    },
    computed: {
        playerOptions() {
            return {
                // videojs options
                language: 'en',
                height: 140,
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [
                    {
                        type: 'video/mp4',
                        src: `/storage/${this.value}`
                    }
                ]
            };
        },

        imageSrc() {
            const file = this.$refs.files?.files[0];
            if (file) {
                return URL.createObjectURL(file);
                // }
                // else if(this.isURL(this.value)) {
                //     return this.value
            } else if (this.preview) {
                return this.preview;
            } else if (this.value) {
                return `/storage/${this.value}`;
            } else {
                return false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.title {
    color: var(--text-dark);
}

.core-upload-file-input {
    display: none;
}

.upload-container {
    &.inline {
        display: flex;
        align-items: center;

        .subtitle {
            margin-top: 0;
            margin-left: 1rem;
        }
    }

    &__image {
        // max-width: 250px;
        width: 100%;

        &.size-small {
            width: 64px;

            i {
                font-size: 1.25rem;
            }
        }

        &.size-medium {
            width: 128px;

            i {
                font-size: 1.75rem;
            }
        }

        &.disabled {
            pointer-events: none;
        }

        &__ratio {
            position: relative;
            width: 100%;

            &.ratio-1-1 {
                padding-bottom: 100%;
            }

            &.ratio-16-9 {
                padding-bottom: 56%;
            }

            &.round {
                & > * {
                    border-radius: 50%;
                }
            }

            & > * {
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 6px;
                object-fit: cover;
            }

            &__content {
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px dashed var(--border-blue-50);
                background-color: var(--bg-blue);

                &:hover {
                    border: 1px dashed var(--secondary-50);
                    cursor: pointer;

                    i {
                        color: var(--secondary-50);
                    }
                }
                // background-color: green;
                i {
                    color: var(--border-blue-50);
                    font-size: 2rem;
                }
            }
        }
    }
}

.title {
    display: inline-block;
    margin-bottom: 0.5rem;
}

.subtitle {
    display: inline-block;
    margin-top: 1rem;
}
</style>
<style lang="scss">
.video-js {
    border-radius: 6px;
    width: 100%;
    height: 100%;

    video {
        border-radius: 6px;
    }

    .vjs-big-play-button {
        top: 50%;
        left: 50%;
        margin-top: -0.75em;
        margin-left: -1.5em;
    }

    .vjs-control-bar {
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
    }
}
</style>
